<template>

    <Toast/>

    <div class="px-6 surface-overlay relative">

        <div class="surface-section px-4 py-8 md:px-6 lg:px-8 overflow-hidden">
            <div class="text-900 font-bold text-4xl mb-4 text-center">Choose the Product and Pricing Plan Option that
                Suits You
            </div>

            <div class="grid">
                <div class="col-12 md:col-12">
                    <div class="card p-fluid">

                        <div class="field">
                            <label for="firstName">First Name</label>
                            <InputText id="firstName" type="text" :disabled="false" v-model.trim="firstName"/>

                            <small v-if="(!firstName)" class="p-error">
                                First Name is required.
                            </small>

                        </div>

                        <div class="field">
                            <label for="lastName">Last Name</label>
                            <InputText id="lastName" type="text" :disabled="false" v-model.trim="lastName"/>

                            <small v-if="(!lastName)" class="p-error">
                                Last Name is required.
                            </small>

                        </div>

                        <div class="field">
                            <label for="email">Email</label>
                            <InputText id="email" type="text" :disabled="false" v-model.trim="email"/>

                            <small v-if="(!email)" class="p-error">
                                Email is required.
                            </small>

                            <small v-if="(emailError)" class="p-error">
                                Email is not valid.
                            </small>

                        </div>

                        <div class="field">
                            <label for="mobile">Mobile</label>
                            <InputText id="mobile" type="text" :disabled="false" v-model.trim="mobile"/>

                            <small v-if="(!mobile)" class="p-error">
                                Mobile is required.
                            </small>

                        </div>

                        <div class="field">
                            <label for="country">Your Location?</label>
                            <Dropdown v-model="selectedLocation" :options="locations"
                                      optionLabel="name" optionValue="code"
                                      placeholder="Select an Option"/>
                        </div>

                        <div class="field">
                            <label for="country">Monthly or Annual Plan? (Note: there is a 20% saving with an Annual
                                Plan)</label>
                            <Dropdown v-model="selectedPlan" :options="plans"
                                      optionLabel="name" optionValue="code"
                                      placeholder="Select an Option"/>
                        </div>

                        <div class="text-900 font-bold text-4xl mb-4 text-center">
                            &nbsp;
                        </div>

                        <div class="text-700 font-bold text-4xl mb-4 text-center">
                            The following series of questions will guide you to choose the best product option with us.
                            You can always change any of these answers and choose the product that you actually want.
                        </div>

                        <div class="field">
                            <label for="turnover">Average Monthly Turnover?</label>
                            <Dropdown v-model="selectedTurnover" :options="turnover"
                                      optionLabel="name" optionValue="code"
                                      placeholder="Select an Option"/>
                        </div>

                        <div class="field">
                            <label for="product">Do You Want a Practice Management Software or a Managed Service (with a
                                Digital Assistant)?</label>
                            <Dropdown v-model="selectedProduct" :options="products"
                                      optionLabel="name" optionValue="code"
                                      placeholder="Select an Option"/>
                        </div>

                        <div v-show="(selectedProduct === 'PM') && (selectedTurnover === '1')" class="field">
                            <label for="range">Which Variation Do You Wish?</label>
                            <Dropdown v-model="selectedRange" :options="rangeOption1"
                                      optionLabel="name" optionValue="code"
                                      placeholder="Select an Option"/>
                        </div>

                        <div
                            v-show="(selectedProduct === 'PM') && ( (selectedTurnover === '2') || (selectedTurnover === '3'))"
                            class="field">
                            <label for="range">Which Variation Do You Wish?</label>
                            <Dropdown v-model="selectedRange" :options="rangeOption2"
                                      optionLabel="name" optionValue="code"
                                      placeholder="Select an Option"/>
                        </div>

                        <div class="field">
                            <label for="digitalAssistant">Do you need to do claim submissions to medical aid
                                companies?</label>
                            <Dropdown v-model="selectedClaimSubmission" :options="confirmation"
                                      optionLabel="name" optionValue="code"
                                      placeholder="Select an Option"/>
                        </div>


                        <div v-show="selectedProduct === 'PM'" class="field">
                            <label for="digitalAssistant">Do You Want to Add a Digital Assistant (supported by a
                                dedicated operational team) at a Cost of R2790 per month (including the practice management software)?</label>
                            <Dropdown v-model="selectedDigitalAssistant" :options="confirmation"
                                      optionLabel="name" optionValue="code"
                                      placeholder="Select an Option"/>
                        </div>

                        <div v-show="(selectedDigitalAssistant === 'Y') || (selectedProduct === 'MS')" class="field">
                            <label for="digitalAssistant">Are you able to capture all appointments for your clients on
                                our Practice Management Software?</label>
                            <Dropdown v-model="selectedAppointmentCapturing" :options="confirmation"
                                      optionLabel="name" optionValue="code"
                                      placeholder="Select an Option"/>
                        </div>

                        <div v-show="(selectedDigitalAssistant === 'Y') || (selectedProduct === 'MS')" class="field">
                            <label for="selectedPractitioners">Number of Additional Practitioners (Other Than the
                                Primary One)?</label>
                            <Dropdown v-model="selectedPractitioners" :options="practitioners"
                                      optionLabel="name" optionValue="code"
                                      placeholder="Select an Option"/>
                        </div>

                        <div class="text-900 font-bold text-4xl mb-4 text-center">
                            &nbsp;
                        </div>

                        <div v-show="(selectedDigitalAssistant === 'Y') || (selectedProduct === 'MS')"
                             class="text-700 text-3xl mb-4 text-center">
                            A Digital Assistant, is supported by a dedicated human team, and will be responsible for
                            answering of phone calls, generation of invoices, submission of claims for each invoice to
                            the relevant medical aid, following up on each claim with the medical aid until it's paid or
                            rejected, following up with each client using an unpaids management process, allocation of
                            payments from clients and payments from each medical aid, and producing
                            a monthly income statement showing all income and expenses for the month.
                        </div>

                        <div v-show="(selectedAppointmentCapturing === 'N')" class="text-700 text-3xl mb-4 text-center">
                            An additional data capturing cost of R1,500 will be added to enable the Digital Assistant
                            and dedicated human team to process manual client instructions and appointment scheduling.
                            Our preference is for each client to capture the appointments on their calendar and the
                            operational
                            processes will then be handled by the Digital Assistant, and supported by the dedicated
                            human team.
                            This saves the client the additional monthly expenses, and saves any manual capturing from
                            our team.
                            Free and unlimited training will be provided by our team to enable the client to be able to
                            handle
                            the creation of the appointments on our practice management software.
                        </div>

                        <div v-show="(selectedProduct === 'PM') && (selectedClaimSubmission === 'Y')"
                             class="text-700 text-3xl mb-4 text-center">
                            Claims submitted via EDI will cost R4.90 per claim, and works on a prepaid concept. A
                            process
                            to load prepaid credits to your account will be provided upon request. You can also submit
                            claims via email, and there is no cost for these submissions.
                        </div>

                        <div v-show="(selectedProduct === 'MS') && (selectedClaimSubmission === 'Y')"
                             class="text-700 text-3xl mb-4 text-center">
                            Claims submitted via EDI will cost R4.90 per claim, and works on a prepaid concept. A credit
                            of
                            R500 will be added to your monthly price and should further credits be required, a process
                            to
                            load prepaid credits to your account will be provided. Our team will not be able
                            to submit claims to each medical aid if there are no prepaid funds.
                        </div>

                        <div v-show="(selectedDigitalAssistant === 'Y') || (selectedProduct === 'MS')"
                             class="text-700 text-3xl mb-4 text-center">
                            Each additional practitioner costs R250 per month.
                        </div>


                        <!--                        <div class="field">-->
                        <!--                            <label for="country">Selected Countries?</label>-->
                        <!--                            <MultiSelect v-model="selectedCountry" :options="countries" optionLabel="name" placeholder="Select Countries" :filter="true">-->
                        <!--                                <template #value="slotProps">-->
                        <!--                                    <div class="inline-flex align-items-center py-1 px-2 bg-primary text-primary border-round mr-2" v-for="option of slotProps.value" :key="option.code">-->
                        <!--                                        <span :class="'mr-2 flag flag-' + option.code.toLowerCase()" style="width: 18px; height: 12px" />-->
                        <!--                                        <div>{{ option.name }}</div>-->
                        <!--                                    </div>-->
                        <!--                                    <template v-if="!slotProps.value || slotProps.value.length === 0">-->
                        <!--                                        <div>Select Countries</div>-->
                        <!--                                    </template>-->
                        <!--                                </template>-->
                        <!--                                <template #option="slotProps">-->
                        <!--                                    <div class="flex align-items-center">-->
                        <!--                                        <span :class="'mr-2 flag flag-' + slotProps.option.code.toLowerCase()" style="width: 18px; height: 12px" />-->
                        <!--                                        <div>{{ slotProps.option.name }}</div>-->
                        <!--                                    </div>-->
                        <!--                                </template>-->
                        <!--                            </MultiSelect>-->
                        <!--                        </div>-->

                        <!--                        <div class="field">-->
                        <!--                            <label for="country">Monthly or Annual Plan? (Note: there is a 20% saving with an Annual Plan)</label>-->
                        <!--                            <Dropdown v-model="selectedPlan" :options="plans"-->
                        <!--                                      optionLabel="name" optionValue="code"-->
                        <!--                                      placeholder="Select an Option"/>-->
                        <!--                        </div>-->

                        <div class="text-900 font-bold text-4xl mb-4 text-center">
                            &nbsp;
                        </div>

                        <div class="text-700 font-bold text-4xl mb-4 text-center">
                            Pricing Option for Review
                        </div>

                        <div class="shadow-2 p-3 h-full flex flex-column surface-card"
                             style="border-radius: 6px">
                            <div class="flex align-items-center">
                                <span class="font-bold text-2xl text-900">{{ amount }}</span>
                                <span v-if="selectedPlan === 'M'" class="ml-2 font-medium text-600">( Monthly )</span>
                                <span v-else class="ml-2 font-medium text-600">( Annually )</span>
                            </div>
                            <hr class="my-3 mx-0 border-top-1 border-none surface-border"/>

                            <ul v-if="selectedProduct === 'PM'" class="list-none p-0 m-0 flex-grow-1">

                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Appointment Scheduling</span>
                                    <br/>
                                </li>

                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Invoicing</span>
                                </li>

                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Payment Allocation</span>
                                </li>

                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Health Insurance Claim Submissions - Paper Based or EDI Based Electronic Submission</span>
                                </li>
                            </ul>

                            <ul v-if="selectedProduct === 'MS'" class="list-none p-0 m-0 flex-grow-1">

                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Practice Management Software</span>
                                    <br/>
                                </li>

                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Digital Assistant, supported by dedicated human team</span>
                                </li>

                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Processing of telephone calls</span>
                                </li>

                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Invoicing</span>
                                </li>

                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Payment Allocation</span>
                                </li>

                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Health Insurance Claim Submissions - Paper Based or EDI Based Electronic Submission</span>
                                </li>
                            </ul>

                            <hr class="mb-3 mx-0 border-top-1 border-none surface-border mt-auto"/>
<!--                            <Button label="Buy Now" class="p-3 w-full mt-auto" @click="processBuy"></Button>-->

                            <Button
                                label="Buy Now"
                                :disabled="!isFormValid"
                                class="p-3 w-full mt-auto custom-button"
                                @click="processBuy"
                            />

                        </div>


                    </div>
                </div>
            </div>

        </div>

    </div>

</template>

<script>
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";
import ProspectService from "@/service/ProspectService";

export default {
    components: {},
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    mounted() {
        UserService.getUserPing()
            .then(data => {
                console.log("[Login][mounted] System is active.");
                console.log("[Login][mounted] Data = ", data);
            })
            .catch(e => {
                console.log("[Login][mounted] System is NOT active.");
                console.log("[Login][mounted] Error = ", e);

                this.userStore.clearUser;
                window.location.href = "/#/login";
                window.location.reload();
            });

        const affiliateReference = this.$route.query.affiliate;
        console.log("[Pricing][mounted] affiliateReference = ", affiliateReference);

        const urlParams = new URLSearchParams(window.location.search);
        const websiteAffiliateReference = urlParams.get("newaffiliate");
        console.log("[Pricing][mounted] websiteAffiliateReference = ", websiteAffiliateReference);

    },
    data() {
        return {
            activeTab: 1,
            userData: {},
            prospect: {},
            submitted: false,
            companyId: 114951,
            firstName: null,
            lastName: null,
            email: null,
            mobile: null,
            stripeLink: null,
            selectedPlan: "M",
            selectedLocation: "ZA",
            selectedTurnover: null,
            selectedProduct: null,
            selectedRange: null,
            selectedDigitalAssistant: null,
            selectedAppointmentCapturing: null,
            selectedClaimSubmission: null,
            selectedPractitioners: null,
            emailError: false,
            confirmation: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            plans: [
                {name: 'Monthly', code: 'M'},
                {name: 'Annual', code: 'A'}
            ],
            turnover: [
                {name: 'Less than R40,000 per month', code: '1'},
                {name: 'Between R40,001 and R100,000 per month', code: '2'},
                {name: 'Over R100,000 per month', code: '3'}
            ],
            products: [
                {name: 'Practice Management Software', code: 'PM'},
                {name: 'Managed Service (with Digital Assistant)', code: 'MS'}
            ],
            rangeOption1: [
                {
                    name: 'IsoEvolve (available for smaller practices, but can also support larger practices with a managed service offering, and available only in the last 2 years, starting at R250 per month)',
                    code: 'I'
                },
                {
                    name: 'smeMetrics (our solution for larger practices, and been in existence for over 10 years, starting at R760 per month)',
                    code: 'S'
                }
            ],
            rangeOption2: [
                {
                    name: 'IsoEvolve (available for smaller practices, but can also support larger practices with a managed service offering, and available only in the last 2 years, starting at R490 per month)',
                    code: 'I'
                },
                {
                    name: 'smeMetrics (our solution for larger practices, and been in existence for over 10 years, starting at R760 per month)',
                    code: 'S'
                }
            ],
            practitioners: [
                {name: 'Zero (0)', code: 0},
                {name: 'One (1)', code: 1},
                {name: 'Two (2)', code: 2},
                {name: 'Three (3)', code: 3},
                {name: 'Four (4)', code: 4},
                {name: 'Five (5)', code: 5}
            ],

            locations: [
                {name: 'South Africa', code: 'ZA'},
                {name: 'United Kingdom', code: 'UK'},
                {name: 'Canada', code: 'CA'},
                {name: 'United States', code: 'US'},
                {name: 'Other', code: 'O'}
            ],
            countries: [
                {name: 'United States', code: 'US'},
                {name: 'Canada', code: 'CA'},
                {name: 'UK', code: 'UK'},
                {name: 'South Africa', code: 'ZA'}
            ],

        }
    },
    watch: {
        // Watch for changes in the email and validate
        email(value) {
            this.emailError = !this.isValidEmail(value);
        },
    },
    computed: {
        amount() {
            // Set default amount for cases where no options are selected
            let baseAmount = 0;
            let currency = "R"

            // Example pricing logic:
            if (this.selectedLocation === 'ZA') {
                currency = "R";
            } else {
                currency = "£";
            }

            console.log("[Pricing][amount] this.selectedProduct = ", this.selectedProduct);

            if (this.selectedProduct === "PM") {
                if (this.selectedRange === "I") {
                    if (this.selectedTurnover === "1") {
                        baseAmount = 250;
                    } else {
                        baseAmount = 490;
                    }
                } else if (this.selectedRange === "S") {
                    baseAmount = 760;
                }

                if (this.selectedDigitalAssistant === "Y") {
                    // baseAmount = baseAmount + 2000;
                    baseAmount = 2760;

                    baseAmount = baseAmount + (this.selectedPractitioners * 250);
                }

                if (this.selectedAppointmentCapturing === "N") {
                    baseAmount = baseAmount + 1500;
                }

            } else if (this.selectedProduct === "MS") {
                baseAmount = 2000 + 760;

                if (this.selectedClaimSubmission === "Y") {
                    baseAmount = baseAmount + 500;
                }

                if (this.selectedAppointmentCapturing === "N") {
                    baseAmount = baseAmount + 1500;
                }

                baseAmount = baseAmount + (this.selectedPractitioners * 250);

            }

            if (this.selectedPlan === 'A') {
                baseAmount *= 10; // Apply annual multiplier
            }

            return `${currency} ${baseAmount}`;
        },
        isFormValid() {
            // Check if all required fields are filled and email is valid
            console.log("[Pricing][isFormValid] this.selectedRange = ", this.selectedRange);
            console.log("[Pricing][isFormValid] this.selectedProduct = ", this.selectedProduct);
            return (
                this.firstName &&
                this.lastName &&
                this.email &&
                this.mobile &&
                this.selectedLocation != null &&
                this.selectedProduct != null &&
                this.selectedPlan != null &&
                this.selectedTurnover != null &&
                this.selectedDigitalAssistant != null &&
                !this.emailError // Ensure no email error
            );
        },
    },
    methods: {
        isValidEmail(email) {
            // Simple email validation regex
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        async processBuy() {

            this.submitted = true;

            if (this.isFormValid) {

                try {

                    var prospectDto = {
                        firstName: String(this.firstName || ''),
                        lastName: String(this.lastName || ''),
                        email: String(this.email || ''),
                        mobile: String(this.mobile || ''),
                        source: 'kitrin.com/pricing',
                    };

                    console.log('[Pricing][processBuy] prospectDto = ', prospectDto);

                    // const response = await ProspectService.createExternalProspect(1, prospectDto);
                    const response = await ProspectService.createExternalProspect(114951, prospectDto);
                    console.log('[Pricing][processBuy] Response = ', response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Successfully created account. Awaiting payment.',
                        life: 3000
                    });
                } catch (error) {
                    console.error('[Pricing][processBuy] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create account. Please try again.',
                        life: 3000
                    });
                }
            }

            this.submitted = false;

            let baseAmount = 0;
            let currency = "R"

            // Example pricing logic:
            if (this.selectedLocation === 'ZA') {
                currency = "R";
            } else {
                currency = "£";
            }

            // Existing Clients
            // smeMetrics (ZAR, Monthly, Existing Client, Basic, 2025) - https://buy.stripe.com/dR69CkfnPdi88wweXb


            console.log("[Pricing][processBuy] this.selectedProduct = ", this.selectedProduct);
            console.log("[Pricing][processBuy] baseAmount = ", baseAmount);
            console.log("[Pricing][processBuy] currency = ", currency);

            if (this.selectedProduct === "PM") {
                if (this.selectedRange === "I") {
                    if (this.selectedTurnover === "1") {
                        baseAmount = 250;
                        this.stripeLink = "https://buy.stripe.com/8wM4i0cbD6TKfYYdSi";
                    } else {
                        baseAmount = 490;
                        this.stripeLink = "https://buy.stripe.com/cN2g0Ib7z6TK2884iB";
                    }
                } else if (this.selectedRange === "S") {
                    baseAmount = 760;
                    this.stripeLink = "https://buy.stripe.com/28o5m46Rjdi8eUUaGU";
                }

                if (this.selectedDigitalAssistant === "Y") {
                    // baseAmount = baseAmount + 2000;
                    baseAmount = 2760;
                    this.stripeLink = "https://buy.stripe.com/cN23dW3F791SfYYeXc"

                    baseAmount = baseAmount + (this.selectedPractitioners * 250);
                }

                if (this.selectedAppointmentCapturing === "N") {
                    baseAmount = baseAmount + 1500;
                }

            } else if (this.selectedProduct === "MS") {
                baseAmount = 2760;
                this.stripeLink = "https://buy.stripe.com/cN23dW3F791SfYYeXc"

                if (this.selectedClaimSubmission === "Y") {
                    baseAmount = baseAmount + 500;
                    this.stripeLink = "https://buy.stripe.com/bIY8yg3F7ba03cc2ar"
                }

                if (this.selectedAppointmentCapturing === "N") {
                    baseAmount = baseAmount + 1500;
                    this.stripeLink = "https://buy.stripe.com/8wM9Ck4Jba5WeUUg1i"
                }

                baseAmount = baseAmount + (this.selectedPractitioners * 250);

            }

            if (this.selectedPlan === 'A') {
                baseAmount *= 10; // Apply annual multiplier
            }

            console.log("[Pricing][processBuy] this.stripeLink = ", this.stripeLink);

            window.open(this.stripeLink, '_blank');

            // if (this.selectedLocation === 'ZA') {
            //     console.log("[Pricing][amount] this.selectedProduct = ", this.selectedProduct);
            //
            //     if (this.selectedProduct === "PM") {
            //         if (this.selectedRange === "I") {
            //             if (this.selectedTurnover === "1") {
            //                 baseAmount = 250;
            //             } else {
            //                 baseAmount = 490;
            //             }
            //         } else if (this.selectedRange === "S") {
            //             baseAmount = 760;
            //         }
            //
            //         if (this.selectedDigitalAssistant === "Y") {
            //             baseAmount = baseAmount + 2000;
            //
            //             baseAmount = baseAmount + (this.selectedPractitioners * 250);
            //         }
            //
            //         if (this.selectedAppointmentCapturing === "N") {
            //             baseAmount = baseAmount + 1500;
            //         }
            //
            //     } else if (this.selectedProduct === "MS") {
            //         baseAmount = 2000 + 760;
            //
            //         if (this.selectedClaimSubmission === "Y") {
            //             baseAmount = baseAmount + 500;
            //         }
            //
            //         if (this.selectedAppointmentCapturing === "N") {
            //             baseAmount = baseAmount + 1500;
            //         }
            //
            //         baseAmount = baseAmount + (this.selectedPractitioners * 250);
            //
            //     }
            //
            //
            //     if (this.selectedPlan === 'A') {
            //         window.open("https://buy.stripe.com/5kA5lG7TDebe6LSdR3", '_blank');
            //     }
            // }
            //
            // if (this.selectedCountry.length === 2) {
            //
            //     if (this.selectedLocation === "CA") {
            //         if (this.selectedPlan === 'A') {
            //             window.open("https://buy.stripe.com/5kA5lG7TDebe6LSdR3", '_blank');
            //         } else {
            //             window.open("https://buy.stripe.com/cN23dya1L7MQdag8wF", '_blank');
            //         }
            //
            //     } else if (this.selectedLocation === "UK") {
            //         if (this.selectedPlan === 'A') {
            //             window.open("https://buy.stripe.com/aEU6pK2zj7MQ1ry5kN", '_blank');
            //         } else {
            //             window.open("https://buy.stripe.com/4gwdScddXgjm8U06oN", '_blank');
            //         }
            //
            //     } else if (this.selectedLocation === "ZA") {
            //         if (this.selectedPlan === 'A') {
            //             window.open("https://buy.stripe.com/cN25lGgq91os3zG6oY", '_blank');
            //         } else {
            //             window.open("https://buy.stripe.com/00gg0kei19UYfio6oV", '_blank');
            //         }
            //
            //     } else {
            //         if (this.selectedPlan === 'A') {
            //             window.open("https://buy.stripe.com/fZe5lG4Hr9UYfio4gm", '_blank');
            //         } else {
            //             window.open("https://buy.stripe.com/8wMbK48XH6IM0nudQS", '_blank');
            //         }
            //     }
            //
            // } else if (this.selectedCountry.length === 3) {
            //     if (this.selectedLocation === "CA") {
            //         if (this.selectedPlan === 'A') {
            //             window.open("https://buy.stripe.com/6oE7tOfm58QU6LS14i", '_blank');
            //         } else {
            //             window.open("https://buy.stripe.com/bIY8xSddXc365HO4gq", '_blank');
            //         }
            //
            //     } else if (this.selectedLocation === "UK") {
            //         if (this.selectedPlan === 'A') {
            //             window.open("https://buy.stripe.com/8wM8xS3Dn5EI7PW9B4", '_blank');
            //         } else {
            //             window.open("https://buy.stripe.com/6oEg0k1vfaZ2c6c14u", '_blank');
            //         }
            //
            //     } else if (this.selectedLocation === "ZA") {
            //         if (this.selectedPlan === 'A') {
            //             window.open("https://buy.stripe.com/4gw3dy1vfgjmfiocNn", '_blank');
            //         } else {
            //             window.open("https://buy.stripe.com/cN29BW1vfgjm0nudRo", '_blank');
            //         }
            //
            //     } else {
            //         if (this.selectedPlan === 'A') {
            //             window.open("https://buy.stripe.com/5kA4hC8XH6IM8U0007", '_blank');
            //         } else {
            //             window.open("https://buy.stripe.com/dR63dygq93wA2vC003", '_blank');
            //         }
            //     }
            //
            // } else if (this.selectedCountry.length === 4) {
            //     if (this.selectedLocation === "CA") {
            //         if (this.selectedPlan === 'A') {
            //             window.open("https://buy.stripe.com/3cs6pK4Hr0kofio8wL", '_blank');
            //         } else {
            //             window.open("https://buy.stripe.com/fZe15q7TD5EIeek14f", '_blank');
            //         }
            //
            //     } else if (this.selectedLocation === "UK") {
            //         if (this.selectedPlan === 'A') {
            //             window.open("https://buy.stripe.com/4gw15qa1Lffi3zGbJd", '_blank');
            //         } else {
            //             window.open("https://buy.stripe.com/eVa8xS8XH2sw9Y4fZp", '_blank');
            //         }
            //
            //     } else if (this.selectedLocation === "ZA") {
            //         if (this.selectedPlan === 'A') {
            //             window.open("https://buy.stripe.com/8wMbK4gq92sw0nubJk", '_blank');
            //         } else {
            //             window.open("https://buy.stripe.com/7sI6pKfm5ffigms8x5", '_blank');
            //         }
            //
            //     } else {
            //         if (this.selectedPlan === 'A') {
            //             window.open("https://buy.stripe.com/fZe6pK4Hrgjm0nuaEM", '_blank');
            //         } else {
            //             window.open("https://buy.stripe.com/5kA9BW8XHd7a6LSbIM", '_blank');
            //         }
            //     }
            //
            // } else {
            //     if (this.selectedLocation === "CA") {
            //         if (this.selectedPlan === 'A') {
            //             window.open("https://buy.stripe.com/28og0k6Pz0ko5HO00c", '_blank');
            //         } else {
            //             window.open("https://buy.stripe.com/cN24hC4Hr3wA4DK4gg", '_blank');
            //         }
            //
            //     } else if (this.selectedLocation === "UK") {
            //         if (this.selectedPlan === 'A') {
            //             window.open("https://buy.stripe.com/eVag0k4Hr4AE4DK28A", '_blank');
            //         } else {
            //             window.open("https://buy.stripe.com/bIY7tOddX0ko2vC3cA", '_blank');
            //         }
            //
            //     } else if (this.selectedLocation === "ZA") {
            //         if (this.selectedPlan === 'A') {
            //             window.open("https://buy.stripe.com/4gwaG0a1L1osgms9AU", '_blank');
            //         } else {
            //             window.open("https://buy.stripe.com/aEU3dyei1ebe4DKdRm", '_blank');
            //         }
            //
            //     } else {
            //         if (this.selectedPlan === 'A') {
            //             window.open("https://buy.stripe.com/bIYaG0ddX9UYc6c9AF", '_blank');
            //         } else {
            //             window.open("https://buy.stripe.com/dR68xSei1c36eek3cd", '_blank');
            //         }
            //     }
            //
            // }

        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
